import React from 'react'

import * as S from './styles'

export type FloatingIconProps = {
  /**
   * Icon source image
   *
   * @example
   * ```tsx
   * <FloatingIcon src={SvgVariable} />
   * ```
   */
  src: string

  /**
   * Image alt text
   *
   * @example
   * ```tsx
   * <FloatingIcon alt={"floating icon"} />
   * ```
   */
  alt?: string

  /**
   * Redirect onclick to this link
   *
   * @example
   * ```tsx
   * <FloatingIcon redirect={url} />
   * ```
   *
   */
  redirectUrl: string

  /**
   * Class name of the button
   *
   * @example
   * ```tsx
   * <FloatingIcon className="button-icon" />
   * ```
   *
   */
  className?: string
}

export const FloatingIcon: React.FC<FloatingIconProps> = ({
  src,
  alt = 'icon',
  redirectUrl,
  className,
}) => {
  const handleClick = () => {
    window.open(redirectUrl, '_blank')
  }

  return (
    <S.FloatingIcon
      icon={src}
      alt={alt}
      onClick={handleClick}
      className={className}
    />
  )
}
